const indexItems = [
  { title: '电影', icon: 'ri-film-line', desc: '院线新片 · 经典佳作 · 类型齐全', count: '5000+' },
  { title: '电视剧', icon: 'ri-tv-2-line', desc: '国产剧 · 港剧 · 韩剧 · 美剧', count: '3000+' },
  { title: '综艺', icon: 'ri-live-line', desc: '热门综艺 · 经典回顾 · 欢笑不断', count: '1200+' },
  { title: '动漫', icon: 'ri-rocket-line', desc: '国漫 · 日漫 · 剧场版 · 连载', count: '2000+' },
  { title: '纪录片', icon: 'ri-earth-line', desc: '自然 · 历史 · 人文 · 科技', count: '800+' },
  { title: '少儿', icon: 'ri-heart-line', desc: '动画 · 益智 · 亲子 · 教育', count: '600+' },
  { title: '微电影', icon: 'ri-camera-line', desc: '短片 · 原创 · 独立制作', count: '400+' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按类型快速浏览，找到你想看的内容分类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="group rounded-xl p-5 md:p-6 bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer text-center"
              style={{ animationDelay: `${idx * 70}ms` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-500 transition-colors mb-3 md:mb-4">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-600 group-hover:text-background-50`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-[11px] text-primary-600 font-medium">{item.count}部影片</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}